export const TABLE_ROW_HIGHT = 24
